export enum Envs {
  DEV = "DEV",
  ALPHA = "ALPHA",
  BETA = "BETA",
  PROD = "PROD",
  DEMO = "DEMO",
}
